import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import InlineSVG from "../inline-svg/inline-svg-component";
import InfoIcon from "../../assets/icons/gradient/info-circle.svg";
import WarningIcon from "../../assets/icons/gradient/warning.svg";
import DangerIcon from "../../assets/icons/gradient/danger.svg";
import CheckIcon from "../../assets/icons/gradient/check.svg";

// test to force client build

const CustomAlert = ({ severity, title, message, actions, ...props }) => {
	return (
		<Alert severity={severity} icon={false} {...props}>
			<div className="flex flex-col md:flex-row md:items-center gap-4">
				<div className="flex-grow">
					{title && (
						<AlertTitle className="flex items-center gap-2">
							{severity === "success" && (
								<InlineSVG
									src={CheckIcon}
									width={24}
									height={24}
									ariaHidden
								/>
							)}
							{severity === "info" && (
								<InlineSVG
									src={InfoIcon}
									width={24}
									height={24}
									ariaHidden
								/>
							)}
							{severity === "warning" && (
								<InlineSVG
									src={WarningIcon}
									width={24}
									height={24}
									ariaHidden
								/>
							)}
							{severity === "error" && (
								<InlineSVG
									src={DangerIcon}
									width={24}
									height={24}
									ariaHidden
								/>
							)}
							{title}
						</AlertTitle>
					)}

					{message && message}
				</div>

				{actions && (
					<div className="md:ml-auto flex-shrink-0">{actions}</div>
				)}
			</div>
		</Alert>
	);
};

export default CustomAlert;
